import React from 'react'

import breakpoints from '../constants/breakpoints'

export const ResponsiveContext = React.createContext({})
export const ResponsiveProvider = ({ children }) => {
  const [width, setWidth] = React.useState(window.innerWidth)
  const [height, setHeight] = React.useState(window.innerHeight)

  const handleWindowResize = () => {
    setWidth(window.innerWidth)
    setHeight(window.innerHeight)
  }

  React.useEffect(() => {
    window.addEventListener('resize', handleWindowResize)
    return () => window.removeEventListener('resize', handleWindowResize)
  }, [])

  return <ResponsiveContext.Provider value={{ width, height }}>{children}</ResponsiveContext.Provider>
}

export const useViewport = () => {
  const { width, height } = React.useContext(ResponsiveContext)
  return { width, height }
}

export const useHideOn = size => {
  const { width } = useViewport()
  const { sm, md, lg, xlg } = breakpoints

  switch (size) {
    case 'sm':
      if (width <= sm) return true
      break

    case 'md':
      if (width > sm && width <= md) return true
      break

    case 'mdd':
      if (width <= md) return true
      break

    case 'mdu':
      if (width > sm) return true
      break

    case 'lg':
      if (width > md && width <= lg) return true
      break

    case 'lgd':
      if (width <= lg) return true
      break

    case 'lgu':
      if (width > md) return true
      break

    case 'xlgu':
    case 'xlg':
      if (width > lg) return true
      break

    default:
      return false
  }
}
export const useIsOn = useHideOn
